import { Entity } from './Entity';
import { ColumnDefinition } from './ColumnDefinition';
import { TableCell } from '@mui/material';

interface TableCellWrapperProps<T extends Entity> {
  row: T;
  columnDefinitions: ColumnDefinition<T>[];
}

const TableCells = <T extends Entity>(props: TableCellWrapperProps<T>) => {
  const rowLen = props.columnDefinitions.length;

  const cells = props.columnDefinitions.map((c, i) => {
    const sx = c.width ? { width: c.width } : {};
    const align = i + 1 === rowLen ? 'right' : 'left';
    const cellContent: JSX.Element =
      c.render !== undefined ? c.render(props.row) : <>{props.row[c.id]}</>;
    return (
      <TableCell key={c.id} sx={sx} style={{ textAlign: align }}>
        {cellContent}
      </TableCell>
    );
  });

  return <>{cells}</>;
};

export default TableCells;
